import {userData} from "@/mixins/userData";

export const formValidation = {
    data() {
        return {
            isDisabled: false,
            isChecked: false,
        };
    },
    watch: {
        haveAccount() {
            this.resetAuthForm();
        }
    },
    methods: {
        isValidAll(isSettings = false) {
            const allRefsArray = Object.values(this.$refs);

            allRefsArray.forEach(ref => {
                ref && ref.validateInput()
            });
            this.isDisabled = allRefsArray.some(ref => {
                if (isSettings) {
                    return ref && !ref.isValid && ref.isRequired;
                } else {
                    return ref && !ref.isValid;
                }
            });

            !this.isChecked && (this.isChecked = true);
        },

        returnToValidSettings() {
            const allRefsArray = Object.values(this.$refs);

            allRefsArray.forEach(ref => {
                if (ref && !ref.isValid && !ref.isRequired) {
                    const vModelValue = ref.$props['modelValue'];
                    const dataKey = Object.keys(this.tempUserData).find(key => this.tempUserData[key] === vModelValue);
                    this.tempUserData[dataKey] = this.oldUserData[dataKey];
                }
            })
        },

        resetAuthForm() {
            const allRefsArray = Object.values(this.$refs);
            allRefsArray.forEach(ref => {
                if(ref) {
                    ref.isValid = true;
                    ref.isBlocked = false;
                    ref.isFocused = false;
                }
            });

            this.isDisabled = false;
            this.isChecked = false;
            this.email = '';
            this.login = '';
            this.password = '';
            this.confirmPassword = '';
        }
    },

    updated() {
        if (this.isChecked) {
            this.isValidAll(this.isSettings);
        }
    }
}